export default __webpack_public_path__ + "static/media/tachie.80802fc1.jpeg";